export const QuizData = [
    
{
    id:0,
    question:'do you have cough',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:1,
    question:'Do you have a runny nose?',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:2,
    question: 'Are you having diarrhea',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:3,
    question:'Do you have headhache?',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:4,
    question:'Are you experiencing body pain?',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:5,
    question:'Are you having sore throat?',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:6,
    question:'Are you having Fever (temperature 37.8degerees C and above)?',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:7,
    question:'Are you having difficulty breathing?',
    options:['yes', 'no'],
    answer: 'no',
},
{
    id:8,
    question:'Are you Feeling fatigue?',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:9,
    question:'Are you having sore throat?',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:10,
    question:'Have you travelled recently (during the past 14 days)?',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:11,
    question:'Do you have a travel history with COVID-19 infected area?',
    options:['yes', 'no'],
    answer: 'no'
},
{
    id:12,
    question:'Do you have direct contact or taking care of a positive COVID-19 patient?',
    options:['yes', 'no'],
    answer: 'no'
}
]